import React, { Component, createRef } from 'react';
import Navbar from '../App/Navbar';
import Footer from '../App/Footer';
import API_Root from '../Constants/API_Root';
import { Link } from 'react-router-dom';
import { auth } from '../Authentication/firebase/firebase';
import PricingComponent from './PricingComponent';
import { authFetch } from '../Authentication/authService';

class Products extends Component {
  constructor(props) {
    super(props);
    this.state = {
      userEmail: null,
      subscriptionType: '',
      paymentMode: '',
    };
    this.pricingContainerRef = createRef();
  }

  componentDidMount() {
    auth.onAuthStateChanged(user => {
      if (user) {
        this.setState({ userEmail: user.email });
      } else {
        this.setState({ userEmail: null });
      }
    });
  }

  componentDidUpdate() {
    console.log(this.state.userEmail);
  }

  handleCheckoutClick = async (subscriptionType, paymentMode) => {
    if (this.state.userEmail === null) {
      window.location.href = '/login';
      return;
    }
    this.setState({ subscriptionType, paymentMode });
    try {
      const response = await authFetch(API_Root + "subscription/create-checkout-session", {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          email: this.state.userEmail,
          subscriptionType,
          paymentMode,
        }),
      });

      const data = await response.json();

      if (response.ok) {
        localStorage.setItem('stripeSessionId', data.sessionId);
        window.location.href = data.url;
      } else {
        console.error('Failed to create checkout session:', data.error);
      }
    } catch (error) {
      console.error('Error:', error);
    }
  };

  scrollLeft = () => {
    if (this.pricingContainerRef.current) {
      this.pricingContainerRef.current.scrollBy({
        left: -400, // adjust this value as needed
        behavior: 'smooth',
      });
    }
  };

  scrollRight = () => {
    if (this.pricingContainerRef.current) {
      this.pricingContainerRef.current.scrollBy({
        left: 400, // adjust this value as needed
        behavior: 'smooth',
      });
    }
  };

  render() {
    return (
      <div className='faq-grid-layout'>
        <Navbar />
        <div className='top-spacer' />
        <div className='banner'>
          <div className='banner-container'>
            <h1>Our Products</h1>
            <p></p>
          </div>
        </div>
        <div className='mainsection'>
            <div className='products-main-container'>
                <h1>Our Products</h1>
                <p>
                Our AI-assisted products are designed to transform how consultants spend their time to deliver E&S project documents.
                </p>
                <h1>myESRA - Your AI-powered E&S Research Assistant</h1>
                <p>
                myESRA transforms how E&S professionals access, manage and utilise data, saving time and enhancing impact. Combining cutting-edge AI with industry expertise, it’s the ultimate solution for environmental and social performance management.
                </p>
                <p><strong>Key Features:</strong></p>
                <ul>
                    <p>
                        1. <strong>Turnkey Solution: </strong>Access everything you need from myESRA’s extensive knowledge base - no uploads required 
                    </p>
                    <p>
                        2. <strong>Accurate, verified results: </strong>Receive precise answers tailored to E&S needs, complete with citations and source links for easy verification.
                    </p>
                    <p>
                        3. <strong>E&S-specific expertise: </strong>Purpose-built and fine-tuned to handle over 20 years of E&S project documents, legislation, policies and more.
                    </p>
                </ul>
                <h1>Why choose myESRA?</h1>
                <p>
                <strong>Save time: </strong>Automate repetitive tasks like document searches.<br />
                <strong>Gain Leverage: </strong>Tap into the most comprehensive E&S-specific knowledge base. <br />
                <strong>Increase impact: </strong>Faster project delivery means you can take on more projects and thus have greater positive impact.
                </p>

                <div className='products-pricing-container' style={{ position: 'relative' }}>
                    {/* Left Arrow Button */}
                    <button
                        onClick={this.scrollLeft}
                        style={{
                            position: 'absolute',
                            left: 0,
                            top: '50%',
                            transform: 'translateY(-50%)',
                            zIndex: 10,
                            background: 'none',
                            border: 'none',
                            fontSize: '2rem',
                            cursor: 'pointer',
                            color: '#000',
                        }}
                        aria-label="Scroll left"
                    >
                        &#8249;
                    </button>

                    {/* Scrollable container wrapping the PricingComponent */}
                    <div
                        ref={this.pricingContainerRef}
                        className="scrollable-container"
                        style={{
                        overflowX: 'auto',
                        width: '100%',
                        }}
                    >
                        <div className="pricing-container-1">
                            <PricingComponent handleCheckoutClick={this.handleCheckoutClick} />
                        </div>
                    </div>

                    {/* Right Arrow Button */}
                    <button
                        onClick={this.scrollRight}
                        style={{
                        position: 'absolute',
                        right: 0,
                        top: '50%',
                        transform: 'translateY(-50%)',
                        zIndex: 10,
                        background: 'none',
                        border: 'none',
                        fontSize: '2rem',
                        cursor: 'pointer',
                        color: '#000',
                        }}
                        aria-label="Scroll right"
                    >
                        &#8250;
                    </button>
                </div>
                <br />
                <h1>privatESRA - Your private research assistant </h1>
                <p>
                    privatESRA was designed to support your work on pre-disclosure and confidential documents,
                    deploying AI to conduct document review, survey analysis and more. Choose from two models
                    with capabilities to chat to document or analyse data for you. 
                </p>
                <p><strong>Key Features:</strong></p>
                <ul>
                    <p>
                        1. <strong>Private and Secure: </strong>Designed for organisations requiring enhanced privacy and security measures. You are in control of your data. 
                    </p>
                    <p>
                        2. <strong>Cloud-based convenience: </strong>Wherever you go, your knowledge base is always there for you! No need to update hardware, privatESRA works on any computer. 
                    </p>
                    <p>
                        3. <strong>Multiple models for different use cases: </strong>use reasoning and text generation for general queries and analysis mode for your survey data. More models are added to unlock additional capabilities. 

                    </p>
                </ul>
                <div className='products-contact'>
                    <p>Available for enterprise clients. Contact us for a quote.</p>

                    <button
                        onClick={() => {
                            window.location.href = "mailto:info@essolutions.ai?subject=Inquiry about privatESRA";
                        }}
                        style={{
                            padding: "10px 20px",
                            backgroundColor: "#3E826D",
                            color: "#fff",
                            border: "none",
                            borderRadius: "4px",
                            cursor: "pointer",
                            
                        }}
                        >
                        Contact Us
                    </button>
                </div>
            </div>
        </div>
        <Footer />
      </div>
    );
  }
}

export default Products;
